import { Component } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ToastService } from '../../shared/services/toast.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  standalone: false,
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  currentPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  errorMessage: string = '';
  currentPasswordType: string = 'password';
  newPasswordType: string = 'password';
  confirmPasswordType: string = 'password';
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isPasswordChanged: boolean = false;

  constructor(
    private api: ApiService,
    private toast: ToastService,
    private auth: AuthService
  ) {}

  onShowPassword(field: string) {
    if (field === 'current') {
      this.showCurrentPassword = !this.showCurrentPassword;
      this.currentPasswordType = this.showCurrentPassword ? 'text' : 'password';
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
      this.newPasswordType = this.showNewPassword ? 'text' : 'password';
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
      this.confirmPasswordType = this.showConfirmPassword ? 'text' : 'password';
    }
  }

  validatePassword(password: string): string[] {
    const errors: string[] = [];
    if (password.length < 12) errors.push('At least 12 characters');
    if (!/[A-Z]/.test(password)) errors.push('1 uppercase letter');
    if (!/[a-z]/.test(password)) errors.push('1 lowercase letter');
    if (!/[0-9]/.test(password)) errors.push('1 number');
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) errors.push('1 special character');
    return errors;
  }

  isPasswordValid(password: string): boolean {
    return this.validatePassword(password).length === 0;
  }

  hasUpperCase(password: string): boolean {
    return /[A-Z]/.test(password);
  }

  hasLowerCase(password: string): boolean {
    return /[a-z]/.test(password);
  }

  hasNumber(password: string): boolean {
    return /[0-9]/.test(password);
  }

  hasSpecialChar(password: string): boolean {
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
  }

  resetPassword() {
    const vm = this;
    if (!vm.currentPassword) {
      vm.errorMessage = 'Please enter current password';
      return;
    }
    if (!vm.newPassword) {
      vm.errorMessage = 'Please enter new password';
      return;
    }
    if (!vm.confirmPassword) {
      vm.errorMessage = 'Please confirm new password';
      return;
    }
    if (vm.newPassword !== vm.confirmPassword) {
      vm.errorMessage = 'New password and confirm password do not match';
      return;
    }
    if (!vm.isPasswordValid(vm.newPassword)) {
      const errors = vm.validatePassword(vm.newPassword);
      vm.errorMessage = 'Password must have: ' + errors.join(', ');
      return;
    }
    vm.errorMessage = '';
    
    const user = vm.auth.getUser();
    const email = user?.email || '';
    
    vm.api.postData('/partners/auth/change-password', {
      email: email,
      currentPassword: vm.currentPassword,
      newPassword: vm.newPassword
    }).subscribe({
      next: (res: any) => {
        if (res && !res.error) {
          vm.isPasswordChanged = true;
          vm.toast.show('Password changed successfully!', 'success');
          const user = vm.auth.getUser();
          if (user) {
            user.isFirstLogin = false;
            vm.auth.setUser(user);
          }
        } else {
          vm.errorMessage = res?.message || 'Failed to change password';
        }
      },
      error: (err) => {
        vm.errorMessage = (typeof err === 'string' ? err : err?.message) || 'Failed to change password';
      }
    });
  }
}